var systemES = {
    "Date.ago": "{{date,ago}}",
    "Date.daymonth": "{{date,daymonth}}",
    "Date.long": "{{date,long}}",
    "Date.relative": "{{date,relative}}",
    "Date.relativetime": "{{date,relativetime}}",
    "Date.short": "{{date,short}}",
    "Fallback.empty_heading": "Sorry, nothing to see here",
    "SelectInput.no_options": "No options",
    "SelectInput.search": "Search",
    "Table.selected": "{{descriptor}} selected"
};

export { systemES as default };
